import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-delivery-status.reducer';

export const ProductDeliveryStatusDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productDeliveryStatusEntity = useAppSelector(state => state.productDeliveryStatus.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productDeliveryStatusDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.productDeliveryStatus.detail.title">ProductDeliveryStatus</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productDeliveryStatusEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="fitengineerBackendV2App.productDeliveryStatus.status">Status</Translate>
            </span>
          </dt>
          <dd>{productDeliveryStatusEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/product-delivery-status" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-delivery-status/${productDeliveryStatusEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductDeliveryStatusDetail;
